/**
 * @file
 * A JavaScript file containing the search functionality
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

domready(function () {
  'use strict';

  var toggle_search = document.getElementById('toggle-search');
  var search = document.getElementsByClassName('search-block-form')[0];
  var body = document.getElementsByTagName("BODY")[0];
  var formInput = document.querySelectorAll('.search-block__form__inner .form-item__textfield')[0];

  function toggleClasses() {
    toggle_search.classList.toggle('toggle-expand--open');
    search.classList.toggle('search-block__form--open');
    body.classList.toggle('js-scroll-off');
    body.classList.toggle('js-search-open');
    // Clear search input.
    formInput.value = '';
  }
  // Search Show/Hide.
  toggle_search.addEventListener('click', toggleClasses);
});
